module.exports = __webpack_public_path__ + "static/media/zoleWon_2500_5000.39ec2d54.png";